import { Box, Button } from '@mui/material';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../core/hooks';
import { Card } from '../../../ui/components';

interface Props {
  exitChangePositionView: () => void;
  saveNewPosition: () => void;
}

export const TopologyServicePositionChangeStatusSection: FunctionComponent<Props> = ({
  exitChangePositionView,
  saveNewPosition
}) => {
  const translate = useAppTranslate();

  return <Card height={'auto'}>
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ padding: '10px' }}>{translate('changePositionSection.description')}</Box>
      <Box sx={{ display: 'flex', gap: 1, marginLeft: 'auto' }}>
        <Button
          variant={'outlined'}
          onClick={() => exitChangePositionView()}
        >{translate('actions.cancel', { ns: 'common' })}</Button>
        <Button
          variant={'contained'}
          onClick={() => saveNewPosition()}
        >{translate('actions.confirm', { ns: 'common' })}</Button>
      </Box>
    </Box>
  </Card>;
};
